import { Dispatch, SetStateAction } from "react";

export type ID = undefined | null | number | string;

export type PaginationLink = {
  label: string;
  active: boolean;
  url: string | null;
  pageNumber: number | null;
};

export type PaginationState = {
  pageNumber: number;
  pageSize: 10 | 30 | 50 | 100;
  total?: number;
  lastPage?: number;
  links?: PaginationLink[];
};
export type City = {
  Id: number;
  id: number;
  name: string;
  districts: District;
  latitude?: string;
  longitude?: string;
};
export type District = {
  name?: string;
  id?: string;
  cityId?: number;
  latitude?: string;
  longitude?: string;
};

export type SortState = {
  sort?: string;
  order?: "asc" | "desc";
};

export type FilterState = {
  filter?: unknown;
};

export type SearchState = {
  search?: string;
};

export type Response<T> = {
  data?: T;
  payload?: {
    message?: string;
    errors?: {
      [key: string]: Array<string>;
    };
    pagination?: PaginationState;
  };
};

export type QueryState = PaginationState &
  SortState &
  FilterState &
  SearchState;

export type QueryRequestContextProps = {
  state: QueryState;
  updateState: (updates: Partial<QueryState>) => void;
};
export type MapContextProps = {
  state: unknown;
};

export const initialQueryState: QueryState = {
  pageNumber: 1,
  pageSize: 10,
};

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
};

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined;
  refetch: () => void;
  isLoading: boolean;
  query: string;
};

export const initialQueryResponse = {
  refetch: () => {},
  isLoading: false,
  query: "",
};

export type ListViewContextProps = {
  selected: Array<ID>;
  onSelect: (selectedId: ID) => void;
  onSelectAll: () => void;
  clearSelected: () => void;
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForDelete?: ID;
  setItemIdForDelete: Dispatch<SetStateAction<ID>>;
  itemIdForUpdate?: ID;
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>;
  isAllSelected: boolean;
  disabled: boolean;
};

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  setItemIdForDelete: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  isAllSelected: false,
  disabled: false,
};
